module.exports = "/images/vendor/flag-icon-css/flags/4x3/si.svg?31fbdc5b5842cfa094afed00d9baf083";